export enum CharterType {
  OneWay = 'ONE_WAY',
  RoundTrip = 'ROUND_TRIP',
  MultiLeg = 'MULTI_LEG'
}
